import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import './HeroSlider.scss';
import { SpinnerIcon } from './../../ui/Icons/SpinnerIcon';

const HeroSlider = ({ slides = [] }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loading, setLoading] = useState(true);
  
    // Fake loading to simulate animation time / allow content to mount smoothly
    useEffect(() => {
      if (slides.length > 0) {
          setLoading(false);
      }
    }, [slides]);
  
    const settings = {
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      beforeChange: (_, next) => setCurrentSlide(next),
    };
  
    return loading ? (
      <div className="hero-slider-loading">
        <SpinnerIcon />
      </div>
    ) : (
      <Slider {...settings} className="hero-slider">
        {slides.map((slide, index) => (
          <section
            key={index}
            className={`hero-slide ${currentSlide === index ? 'active' : ''}`}
          >
            <div className="wrapper wrapper--small hero-slide-wrapper">
                <h1 className="hero-slide-title">{slide.title}</h1>
                <h2 className="hero-slide-typography h4">{slide.description}</h2>
                {/* <button className="cta-filled">{slide.cta}</button> */}
            </div>
            <img
              className="hero-slide-image"
              src={slide.imageUrl}
              alt={`Hero Slide ${index + 1}`}
            />
          </section>
        ))}
      </Slider>
    );
  };
  
  export default HeroSlider;